import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import {
  CurrentAccountAccDateResult,
  CurrentAccountAccItemEditData,
  CurrentAccountAccItemLog,
  CurrentAccountAccItemSave,
  CurrentAccountAccItemSaveResult,
  CurrentAccountActionItem,
  CurrentAccountPreAccError,
  CurrentAccountPreAccLookups,
  CurrentAccountSetStatusResult,
  CurrentAccountUploadFlag,
  CurrentAccountUploadFlagsResult,
} from "../models/CurrentAccountPreAccounting";

export default class CurrentAccountPreAccountingApi {
  // Böngésző lookupok (kontír státuszok, is_up_changeable)
  static getLookups(): Promise<CurrentAccountPreAccLookups> {
    return http
      .get<ApiResponse<CurrentAccountPreAccLookups>>(`current-account-pre-accounting/lookups`)
      .then(handleApiResponse);
  }

  // Egy művelet tételei a kontír soraikkal (K2D dw_1 + dw_action_acc egy körben)
  static getItems(actionId: number): Promise<CurrentAccountActionItem[]> {
    return http
      .get<ApiResponse<CurrentAccountActionItem[]>>(`current-account-pre-accounting/${actionId}/items`)
      .then(handleApiResponse);
  }

  // Egy művelet kontírozási hibalistája (K2D pb_err → mmaccinvserr, prefix 'ACT')
  static getErrors(actionId: number): Promise<CurrentAccountPreAccError[]> {
    return http
      .get<ApiResponse<CurrentAccountPreAccError[]>>(`current-account-pre-accounting/${actionId}/errors`)
      .then(handleApiResponse);
  }

  // A tételek Felad (is_up) jelölőjének mentése (K2D pb_ok)
  static saveUploadFlags(
    actionId: number,
    items: CurrentAccountUploadFlag[]
  ): Promise<CurrentAccountUploadFlagsResult> {
    return http
      .post<ApiResponse<CurrentAccountUploadFlagsResult>>(
        `current-account-pre-accounting/${actionId}/upload-flags`,
        { items }
      )
      .then(handleApiResponse);
  }

  // Egy kontír sor szerkesztő-adatai és választékai (K2D w_popup_act_cont_mod megnyitása)
  static getAccItemEditData(accItemId: number): Promise<CurrentAccountAccItemEditData> {
    return http
      .get<ApiResponse<CurrentAccountAccItemEditData>>(
        `current-account-pre-accounting/acc-items/${accItemId}/edit-data`
      )
      .then(handleApiResponse);
  }

  // Egy kontír sor módosítása (K2D w_popup_act_cont_mod pb_ok)
  static saveAccItem(
    accItemId: number,
    request: CurrentAccountAccItemSave
  ): Promise<CurrentAccountAccItemSaveResult> {
    return http
      .post<ApiResponse<CurrentAccountAccItemSaveResult>>(
        `current-account-pre-accounting/acc-items/${accItemId}`,
        request
      )
      .then(handleApiResponse);
  }

  // Egy kontír sor módosítás-naplója (K2D ue_naplo → w_popup_log)
  static getAccItemLog(actionId: number, accItemId: number): Promise<CurrentAccountAccItemLog[]> {
    return http
      .get<ApiResponse<CurrentAccountAccItemLog[]>>(
        `current-account-pre-accounting/${actionId}/acc-items/${accItemId}/log`
      )
      .then(handleApiResponse);
  }

  // A kijelölt műveletek könyvelési dátumának csoportos módosítása
  // (K2D w_popup_acc_date_mod → f_change_action_acc_date)
  static changeAccDate(actionIds: number[], accDate: string): Promise<CurrentAccountAccDateResult> {
    return http
      .post<ApiResponse<CurrentAccountAccDateResult>>(`current-account-pre-accounting/acc-date`, {
        actionIds,
        accDate,
      })
      .then(handleApiResponse);
  }
  // Csoportos kontír státusz állítás (K2D ue_menu_acc_status): 3 = Feladható,
  // 6 = Fők. rendsz. feladva, 33 = Vissza feladhatóba, 9 = Nem feladandó.
  // Az allowDirectPost a K2D rejtett "egyből feladva" jogosultsága: az 5-ös állapotú
  // művelet is feladható egy lépésben.
  // K2D pb_cont (Kontírozás gomb): a kijelölt műveletek újrakontírozása. A recontNotPostable
  // a K2D "Nem feladandó" státuszú műveletre feltett kérdésének megerősítése.
  static recont(actionIds: number[], recontNotPostable = false): Promise<CurrentAccountSetStatusResult> {
    return http
      .post<ApiResponse<CurrentAccountSetStatusResult>>(`current-account-pre-accounting/recont`, {
        actionIds,
        recontNotPostable,
      })
      .then(handleApiResponse);
  }

  static setStatuses(
    status: number,
    actionIds: number[],
    allowDirectPost = false
  ): Promise<CurrentAccountSetStatusResult> {
    return http
      .post<ApiResponse<CurrentAccountSetStatusResult>>(
        `current-account-pre-accounting/set-status/${status}`,
        { actionIds, allowDirectPost }
      )
      .then(handleApiResponse);
  }

}
